var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-circlehValue",attrs:{"id":"container-circlehValue"}},[_c('canvas',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"id":_vm.canvasId}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPrompt),expression:"isPrompt"}],ref:"prompt",staticClass:"prompt",style:({
      left: _vm.pX + 'px',
      top: _vm.pY + 'px',
      width: _vm.pWidth + 'px',
      height: _vm.pHeight + 'px',
    })},[_vm._v("用户改善全部可控风险因素后，可达到的最高健康值")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTargetPrompt),expression:"isTargetPrompt"}],ref:"prompt1",staticClass:"prompt",style:({
      left: _vm.pTargetX + 'px',
      top: _vm.pTargetY + 'px',
      width: _vm.pTargetWidth + 'px',
      height: _vm.pTargetHeight + 'px',
    })},[_vm._v("用户当前健康管理完成后，可达到的最高健康值")])])
}
var staticRenderFns = []

export { render, staticRenderFns }